package com.havn.app.core.platform

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

enum class HavnCameraFacing {
    Front,
    Back
}

@Composable
expect fun HavnQrScannerPreview(
    active: Boolean,
    cameraFacing: HavnCameraFacing = HavnCameraFacing.Back,
    onQrScanned: (String) -> Unit,
    onError: (String) -> Unit,
    modifier: Modifier = Modifier
)
